import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { OnboardingLiveListPeriod } from "../../gql/graphql.ts";
import { OnboardingLivesTab } from "../OnboardingLivePaths.ts";

const pastPeriodParam = "past";

export function useOnboardingLivesScreenUrlState() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab =
    searchParams.get("tab") === OnboardingLivesTab.Plans
      ? OnboardingLivesTab.Plans
      : OnboardingLivesTab.Lives;
  const period =
    searchParams.get("period") === pastPeriodParam
      ? OnboardingLiveListPeriod.Past
      : OnboardingLiveListPeriod.Upcoming;

  const setTab = useCallback(
    (nextTab: OnboardingLivesTab) =>
      setSearchParams(
        nextTab === OnboardingLivesTab.Plans ? { tab: nextTab } : {},
        { replace: true },
      ),
    [setSearchParams],
  );

  const setPeriod = useCallback(
    (nextPeriod: OnboardingLiveListPeriod) =>
      setSearchParams(
        nextPeriod === OnboardingLiveListPeriod.Past
          ? { period: pastPeriodParam }
          : {},
        { replace: true },
      ),
    [setSearchParams],
  );

  return { tab, period, setTab, setPeriod };
}
